module.exports = __webpack_public_path__ + "static/img/Geos-2022-Noel.bbffb35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Noel.png
// module id = LKZl
// module chunks = 0